export default __webpack_public_path__ + "static/media/blogImage1.fb8c5c0d.jpg";